module.exports = __webpack_public_path__ + "0366214bfe969b706a972f0601f4e443.glb";